export const toggleSnackbar = (message, open) => ({
  type: 'TOGGLE_SNACKBAR',
  open,
  message,
})
